// @flow

export { default } from './FormLabel';
